import { Navigate, Route, Routes } from 'react-router-dom';

import Module from '../../layouts/Module';
import ModuleList from '../../components/ModuleList';

const Reports = ({ route }: { route: Route }) => (
  <Module route={route}>
    <Routes>
      {route.routes?.map((route) => (
        <Route
          element={
            <ModuleList routes={route.routes} show_favorites={route.show_favorites} type="report" />
          }
          key={route.id}
          path={route.path}
        />
      ))}
      <Route element={<Navigate replace to={route.routes[0]?.path} />} path="*" />
    </Routes>
  </Module>
);

export default Reports;
